export const forms = {
  addresses: {
    sectionAddress: 'Morada',
    zipCode: 'Código Postal',
    postalAddress: 'Designação postal',
    localization: 'Localidade',
    typeArteria: 'Tipo de Rua',
    policeNumber: 'N.º da Porta',
    floor: 'Andar',
    doorNumber: 'Lado',
    complement: 'Informação complementar de morada',
  },
  ownerAddress: 'Morada do proprietário',
  updateOwnerAddressLabel: 'Editar morada do proprietário*',
}
